// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YN_b","col":"styles_col__3XbWT"};